import React from "react";
import { useSelector } from "react-redux";

import { BreadCrumbItem } from "./BreadCrumbItem/BreadCrumbItem";

import {
  _ListContainer as ListContainer,
  _WidthContainer as WidthContainer,
} from "./style";
import { FixedStyle } from "./FixedStyle";

export const BreadCrumbList = () => {
  const init = useSelector((state) => state.init);
  const Uterum = useSelector((state) => state.Uterum);
  const requests = useSelector((state) => state.requests);

  const { baseRoute, alias } = init;

  function isEnabled(step) {
    const { requestSize, requestDesign_Aggregated, requestSummary_Aggregated } =
      requests.status;

    switch (step) {
      case "1":
        return true;
      case "2":
        return Boolean(Uterum.Season);
      case "3":
      case "4":
      case "5":
        return (
          requestSize === "fulfilled" ||
          requestDesign_Aggregated === "fulfilled" ||
          requestSummary_Aggregated === "fulfilled"
        );
      default:
        console.warn("Unexptected step identifier in BreadCrumbList");
        return false;
    }
  }

  const stepArray = [
    {
      step: "1",
      icon: `${init.assetBaseUrl}/store/uterumsguide2016/icons/weather.png`,
    },
    {
      step: "2",
      icon: `${init.assetBaseUrl}/store/uterumsguide2016/icons/model.png`,
    },
    {
      step: "3",
      icon: `${init.assetBaseUrl}/store/uterumsguide2016/icons/size.png`,
    },
    {
      step: "4",
      icon: `${init.assetBaseUrl}/store/uterumsguide2016/icons/design.png`,
    },
    {
      step: "5",
      icon: `${init.assetBaseUrl}/store/uterumsguide2016/icons/summary.png`,
    },
  ];

  return (
    <>
      <FixedStyle />
      <ListContainer className="BreadCrumbList hide-on-print">
        <WidthContainer>
          {stepArray.map((item) => (
            <BreadCrumbItem
              key={`breadcrumb-item-${item.step}`}
              step={item.step}
              text={alias[`bfcStep${item.step}`]}
              icon={item.icon}
              link={`${baseRoute}/step${item.step}`}
              isEnabled={isEnabled(item.step)}
            />
          ))}
        </WidthContainer>
      </ListContainer>
    </>
  );
};
